import { isXOptionCompanion } from '../isXOptionCompanion';
import { CartPolicy } from './types';
import { pass } from './cartLineHelpers';

export const uhxCompanionRemovalPolicy: CartPolicy = (input, cart, meta) => {
  if (
    !cart ||
    !meta.ultrahumanXAdded ||
    meta.removedLineId !== meta.ultrahumanXAdded.id
  ) {
    return pass(input);
  }

  const removeSet = new Set(input.lineItemsToRemove ?? []);
  let appended = false;
  for (const { node } of cart.lines.edges) {
    if (node.id === meta.removedLineId) continue;
    if (isXOptionCompanion(node.merchandise.id) && !removeSet.has(node.id)) {
      removeSet.add(node.id);
      appended = true;
    }
  }

  if (!appended) return pass(input);
  return {
    input: { ...input, lineItemsToRemove: Array.from(removeSet) },
    reasons: ['remove X-option M1 companions on UHX removal'],
  };
};
